import React from 'react';
import { motion } from 'framer-motion';
import { PlaceholderImage } from '../components/PlaceholderImage';
export function AboutPage() {
  const stats = [{
    value: '18',
    label: 'Age'
  }, {
    value: '13',
    label: 'Years in USA'
  }, {
    value: '2024',
    label: 'National Champion'
  }, {
    value: '1',
    label: 'World Championship Representation'
  }];
  return <main className="min-h-screen pt-32 pb-20 px-6" data-id="element-63">
      <div className="max-w-7xl mx-auto" data-id="element-64">
        {/* Hero Section */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} className="mb-16" data-id="element-65">
          <h1 className="text-5xl md:text-7xl font-heading text-white inline-block relative" data-id="element-66">
            THE FIGHTER
            <div className="absolute -bottom-2 left-0 w-1/2 h-1 bg-accent-blue" data-id="element-67"></div>
          </h1>
        </motion.div>

        {/* Content Grid */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center mb-24" data-id="element-68">
          {/* Text Column */}
          <motion.div initial={{
          opacity: 0,
          x: -20
        }} animate={{
          opacity: 1,
          x: 0
        }} transition={{
          delay: 0.2
        }} className="space-y-8" data-id="element-69">
            <div className="prose prose-invert prose-lg font-body text-gray-300" data-id="element-70">
              <p data-id="element-71">
                Aleks Szulc is an 18-year-old athlete born in Poland who spent
                13 years living in the US. He has been training kickboxing his
                entire life, forging a discipline that transcends borders.
              </p>
              <p data-id="element-72">
                In 2024, his relentless dedication culminated in winning the
                Polish Championships. Following this victory, he was selected to
                represent the Polish National Team at the World Championships,
                cementing his status as one of the elite competitors in his
                division.
              </p>
            </div>

            <blockquote className="border-l-4 border-accent-blue pl-6 py-2" data-id="element-73">
              <p className="text-xl italic font-body text-white" data-id="element-74">
                "Raised in two countries. Shaped by both. Defined by neither."
              </p>
            </blockquote>

            {/* Stats Row */}
            <div className="grid grid-cols-2 md:grid-cols-4 gap-6 pt-8 border-t border-dark-border" data-id="element-75">
              {stats.map((stat, idx) => <div key={idx} className="flex flex-col" data-id="element-76">
                  <span className="text-4xl font-heading text-accent-blue" data-id="element-77">
                    {stat.value}
                  </span>
                  <span className="text-xs font-body text-gray-400 uppercase tracking-wider mt-1" data-id="element-78">
                    {stat.label}
                  </span>
                </div>)}
            </div>
          </motion.div>

          {/* Image Column */}
          <motion.div initial={{
          opacity: 0,
          x: 20
        }} animate={{
          opacity: 1,
          x: 0
        }} transition={{
          delay: 0.4
        }} className="space-y-6" data-id="element-79">
            <img src="https://cdn.magicpatterns.com/uploads/1h7oWNiKAYpbnU3aVRwDpR/IMG_6399.jpg" alt="Professional portrait of Aleks Szulc" className="w-full rounded-xl shadow-2xl object-cover aspect-[3/4]" data-id="element-80" />
          </motion.div>
        </div>

        {/* Secondary Image Section */}
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="w-full" data-id="element-81">
          <div className="grid grid-cols-3 gap-3 md:gap-6 max-w-lg md:max-w-none mx-auto" data-id="element-82">
            <div className="rounded-xl overflow-hidden shadow-2xl aspect-[3/4]" data-id="element-83">
              <img src="https://cdn.magicpatterns.com/uploads/aq4y6yvLadHopTocaDnsY4/IMG_8026.jpg" alt="Aleks training with Polish National Kickboxing Team" className="w-full h-full object-cover" data-id="element-84" />
            </div>
            <div className="rounded-xl overflow-hidden shadow-2xl aspect-[3/4]" data-id="element-85">
              <img src="https://cdn.magicpatterns.com/uploads/6hZHSa6cTR7dd95AykwPLY/IMG_4352.jpg" alt="Aleks ringside at competition" className="w-full h-full object-cover" data-id="element-86" />
            </div>
            <div className="rounded-xl overflow-hidden shadow-2xl aspect-[3/4]" data-id="element-87">
              <img src="https://cdn.magicpatterns.com/uploads/qXZVfk8wrs6Uj4eUKeoxD5/IMG_6696.jpg" alt="Aleks in-ring fight photo" className="w-full h-full object-cover" data-id="element-88" />
            </div>
          </div>
        </motion.div>
      </div>
    </main>;
}